import CommonFooter from '@openclassrooms/common-app/footer/components/Footer';
import { useCurrentUserContext, useUpdateUser } from '@openclassrooms/data-connect-web/users';

import { LANG_REGEXP } from 'Modules/i18n/services/getConfiguration';
import browser from '@openclassrooms/utils/browser';

export default function Footer() {
  const { isConnected, userId } = useCurrentUserContext();
  const [, { mutateAsync: updateUser }] = useUpdateUser({ userId, context: 'Footer:LangSelector' });

  return (
    <CommonFooter
      onChangeLang={async (newLang: string) => {
        if (isConnected) {
          await updateUser({ locale: newLang });
        }
        const { window, document } = browser;

        if (!window || !document) {
          return;
        }

        const { pathname, search, href } = window.location;
        const newPath = pathname.replace(LANG_REGEXP, `/${newLang}/`);
        let newURL = `${newPath}${search}`;

        // remove all get args in the url before changing language on search
        if (href.match(/\/courses|search\?/)) {
          newURL = newPath;
        }

        location.assign(newURL);
      }}
    />
  );
}
